// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './orders.es-AR.json';
import esCL from './orders.es-CL.json';
import esCO from './orders.es-CO.json';
import esMX from './orders.es-MX.json';
import ptBR from './orders.pt-BR.json';

const ordersTranslations: DomainTranslations = {
  name: 'orders',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.CHILE]: esCL,
    [Locale.COLOMBIA]: esCO,
  },
};

export default ordersTranslations;
